import { supabase } from "@/lib/supabaseClient";

export async function fetchReferralInviteBanner(referralCode) {
  const code = String(referralCode || "").trim().toLowerCase();
  if (!code) return null;

  const { data, error } = await supabase.rpc("get_referral_invite_banner", {
    p_referral_code: code,
  });
  if (error) {
    // The banner is trust-building UI, not signup-critical. If the display
    // lookup fails, keep signup usable and hide the banner rather than
    // rendering incomplete referral text.
    // eslint-disable-next-line no-console
    console.warn("[signup] referral invite banner lookup failed", error);
    return null;
  }
  return data || null;
}
